import type { Filter, FilterDataSwitch } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationDictionary } from '@/app/components/translations/createTranslationDictionary.ts';
import { getTranslationServer } from '@/app/components/translations/createTranslationDictionary.ts';
import { isBeachHoliday } from '@/app/common/filters/groups/isBeachHoliday.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import { removePlaceholders } from '@/app/components/search/utils/translationNodes.tsx';

type CreateBlueFlagFilters = {
  searchParams: SearchParams;
  translationDictionary: TranslationDictionary;
};
export const createBlueFlagFilters = ({ searchParams, translationDictionary }: CreateBlueFlagFilters): Filter[] => {
  const showBlueFlagFilter = isBeachHoliday(searchParams);
  const blueFlagBaseLabel = getTranslationServer('vacation.oss.filters.blue_flag.text', translationDictionary);
  const blueFlagLabel = removePlaceholders(blueFlagBaseLabel);
  const blueFlagFilter: Filter | undefined = showBlueFlagFilter
    ? {
        name: FILTER_NAME.BLUE_FLAG,
        type: FILTER_TYPE.SWITCH,
        data: {
          label: blueFlagLabel,
          labelEmphasis: blueFlagBaseLabel,
          selected: searchParams?.[URLParameters.BLUE_FLAG] === '1',
        } as FilterDataSwitch,
      }
    : undefined;

  return [...[blueFlagFilter]].filter((f) => !!f);
};
